<template>
    <header class="header-wrapper">
        <nav class="header-nav">
            <ul>
                <li>
                    <router-link to="/">
                        <span class="mtitle">Home</span>
                        <!-- <img :src="require('@/assets/images/home-icon.gif')" alt="Icon"/> -->
                        <!-- <img :src="require('@/assets/images/home-icon.svg')" alt="Icon"/> -->
                        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="50px" height="50px"><path d="M 24.960938 2.1015625 A 1.0001 1.0001 0 0 0 24.386719 2.3105469 L 1.3867188 20.210938 A 1.0001 1.0001 0 1 0 2.6132812 21.789062 L 4 20.708984 L 4 48 A 1.0001 1.0001 0 0 0 5 49 L 18.832031 49 A 1.0001 1.0001 0 0 0 19.158203 49 L 30.832031 49 A 1.0001 1.0001 0 0 0 31.158203 49 L 45 49 A 1.0001 1.0001 0 0 0 46 48 L 46 20.708984 L 47.386719 21.789062 A 1.0001 1.0001 0 1 0 48.613281 20.210938 L 25.613281 2.3105469 A 1.0001 1.0001 0 0 0 24.960938 2.1015625 z M 25 4.3671875 L 44 19.154297 L 44 47 L 32 47 L 32 29 A 1.0001 1.0001 0 0 0 31 28 L 19 28 A 1.0001 1.0001 0 0 0 18 29 L 18 47 L 6 47 L 6 19.154297 L 25 4.3671875 z M 20 30 L 30 30 L 30 47 L 20 47 L 20 30 z"/></svg>
                    </router-link>
                </li>
                <li>
                    <router-link to="/about">
                        <span class="mtitle">About</span>
                        <!-- <img :src="require('@/assets/images/user-icon.gif')" alt="Icon"/> -->
                        <img :src="require('@/assets/images/user-icon.png')" alt="Icon"/>
                    </router-link>
                </li>
                <li>
                    <router-link to="/projects">
                        <span class="mtitle">Projects</span>
                        <!-- <img :src="require('@/assets/images/user-icon.gif')" alt="Icon"/> -->
                        <img :src="require('@/assets/images/product-icon.png')" alt="Icon"/>
                    </router-link>
                </li>
                <li>
                    <router-link to="/products">
                        <span class="mtitle">Products</span>
                        <!-- <img :src="require('@/assets/images/user-icon.gif')" alt="Icon"/> -->
                        <img :src="require('@/assets/images/shopping-icon.png')" alt="Icon"/>
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="header-right-action">
            <button @click="moodHandler" class="night-day-mood-btn" type="button">
                <i v-if="dayNightMood" class="lar la-sun"></i>
                <i v-else class="las la-moon"></i>
            </button>
            <router-link to="/contact" class="theme-btn hire-me-btn">
                <span class="btn-shape"></span>
                <span class="btn-shape"></span>
                <span class="btn-shape"></span>
                <span class="plus-icon">+</span> Hire Me
            </router-link>
        </div>
    </header>
    
</template>

<script>
export default {
    name: 'OhiloHeader',
    data() {
        return {
            dayNightMood: false
        }
    },
    methods: {
        moodHandler() {
            let isNightMood = localStorage.getItem('isNightMood');
            if (!isNightMood) {
                localStorage.setItem('isNightMood', 'true');
                isNightMood = localStorage.getItem('isNightMood');
                
                if (localStorage.getItem('isNightMood') == 'true') {
                    this.dayNightMood = true;
                } else {
                    this.dayNightMood = false;
                }

                this.$emit('nightMood');
                return;
            }

            if (localStorage.getItem('isNightMood') == 'true') {
                this.dayNightMood = false;
            } else {
                this.dayNightMood = true;
            }

            if (isNightMood == 'true') {
                isNightMood = 'false';
            } else {
                isNightMood = 'true';
            }
            localStorage.setItem('isNightMood', isNightMood);
            this.$emit('nightMood');
        }
    },
	mounted() {
		if (localStorage.getItem('isNightMood') == 'true') {
			this.dayNightMood = true;
		} else {
			this.dayNightMood = false;
		}
	}
}
</script>